import { useEffect } from "react";

const SCRIPT_ID = "vorinchat-embed-script";

export function VorinChatEmbed() {
  useEffect(() => {
    const siteKey = import.meta.env.VITE_VORINCHAT_SITE_KEY?.trim();

    if (!siteKey) {
      return;
    }

    const baseUrl =
      import.meta.env.VITE_VORINCHAT_BASE_URL?.trim() || "https://chat.vorinvista.com";

    const existingScript = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;
    if (existingScript) {
      return;
    }

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = `${baseUrl.replace(/\/+$/, "")}/chat/embed.js`;
    script.async = true;
    script.dataset.siteKey = siteKey;
    script.dataset.title = "VenueX Concierge";

    document.body.appendChild(script);

    return () => {
      script.remove();
      document.querySelectorAll(".vorinchat-embed-shell").forEach((node) => node.remove());
      document.querySelectorAll(".vorinchat-embed-close").forEach((node) => node.remove());
    };
  }, []);

  return null;
}
